import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { useCallback, useEffect, useState } from 'react'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { Center } from '../../../../components/Center'
import EmbalagensService from '../../../../services/database/EmbalagensService'

export function ModalEmb({
  title,
  isOpen,
  onClose,
  onRequest,
  isRequestLoading,
  id,
}) {
  const [descricao, setDescricao] = useState('')
  const [embalagem, setEmbalagem] = useState('')

  const [isEmbLoading, setIsEmbLoading] = useState(false)

  const getById = useCallback(async (id) => {
    try {
      setIsEmbLoading(true)

      const data = await EmbalagensService.getById(id)

      setDescricao(data.descricao)
      setEmbalagem(data.embalagem)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível carregar os dados do embalagem!',
      )
    } finally {
      setIsEmbLoading(false)
    }
  }, [])

  useEffect(() => {
    if (id) {
      getById(id)
    }
  }, [id, getById])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          {isEmbLoading ? (
            <Center>
              <CustomSpinner size={40} />

              <h3
                style={{
                  margin: 0,
                }}
              >
                Carregando...
              </h3>
            </Center>
          ) : (
            <>
              <Col>
                <Form.Label>Descricao</Form.Label>

                <Form.Control
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                />
              </Col>

              <Col>
                <Form.Label>Embalagem</Form.Label>

                <Form.Control
                  value={embalagem}
                  onChange={(e) => setEmbalagem(e.target.value)}
                  onKeyDown={(e) => {
                    if (String(e.target.value).trim().length > 0) {
                      if (e.key === 'Enter') {
                        onRequest({ id, embalagem, descricao })
                      }
                    }
                  }}
                />
              </Col>
            </>
          )}
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Salvar"
          color="#229954"
          onClick={() => onRequest({ id, embalagem, descricao })}
          isLoading={isRequestLoading}
          isDisabled={
            !descricao.trim() || !embalagem.trim() || isRequestLoading
          }
          isLoadingText="Salvando..."
        >
          <CheckCircleFill />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          color="#b03a2e"
          isDisabled={isRequestLoading}
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
